// Draws the BWGELA certificate on a canvas. Shared by course completion and the sample certificate page.
const LOGO_SRCS = ['trinity', 'cpd', 'cambridge'].map(n => `/brand/accreditation/${n}.png`);
let logoPromise;
export const loadCertLogos = () => {
  logoPromise = logoPromise || Promise.all(LOGO_SRCS.map(src => new Promise(res => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = src;
  }))).then(list => list.filter(Boolean));
  return logoPromise;
};

export const drawCertificate = ({ name, courseTitle, levelLine, detail, accent, company, code, sample = false, logos = [], date = new Date() }) => {
  const W = 1600;
  const H = 1130;
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#0f0f0f';
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = '#F5F5DC';
  ctx.lineWidth = 6;
  ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.strokeStyle = 'rgba(245,245,220,0.4)';
  ctx.lineWidth = 2;
  ctx.strokeRect(60, 60, W - 120, H - 120);
  ctx.textAlign = 'center';

  ctx.fillStyle = '#F5F5DC';
  ctx.font = '600 48px Georgia, serif';
  ctx.fillText('BWGELA', W / 2, 175);
  ctx.fillStyle = 'rgba(245,245,220,0.6)';
  ctx.font = '22px Georgia, serif';
  ctx.fillText('CERTIFICATE OF COMPLETION', W / 2, 225);
  ctx.strokeStyle = 'rgba(245,245,220,0.3)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(W / 2 - 160, 255);
  ctx.lineTo(W / 2 + 160, 255);
  ctx.stroke();

  ctx.fillStyle = 'rgba(255,255,255,0.7)';
  ctx.font = '24px Georgia, serif';
  ctx.fillText('This is to certify that', W / 2, 360);
  ctx.fillStyle = '#F5F5DC';
  ctx.font = 'italic 72px Georgia, serif';
  ctx.fillText(name, W / 2, 460);
  ctx.fillStyle = 'rgba(255,255,255,0.7)';
  ctx.font = '24px Georgia, serif';
  ctx.fillText('has successfully completed', W / 2, 545);
  ctx.fillStyle = '#F5F5DC';
  ctx.font = 'bold 40px Georgia, serif';
  ctx.fillText(courseTitle, W / 2, 640);

  ctx.font = '28px Georgia, serif';
  if (accent) {
    const tw = ctx.measureText(levelLine).width + 56;
    ctx.fillStyle = accent.bg;
    ctx.beginPath();
    ctx.roundRect(W / 2 - tw / 2, 666, tw, 46, 8);
    ctx.fill();
    ctx.fillStyle = accent.text;
    ctx.fillText(levelLine, W / 2, 699);
  } else {
    ctx.fillStyle = 'rgba(245,245,220,0.8)';
    ctx.fillText(levelLine, W / 2, 695);
  }

  if (detail) {
    ctx.fillStyle = 'rgba(255,255,255,0.55)';
    ctx.font = '20px Georgia, serif';
    ctx.fillText(detail, W / 2, 775);
  }

  if (company) {
    ctx.fillStyle = 'rgba(245,245,220,0.8)';
    ctx.font = 'italic 26px Georgia, serif';
    ctx.fillText(company, W / 2, detail ? 835 : 795);
  }

  const dateStr = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  ctx.strokeStyle = 'rgba(245,245,220,0.4)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(W / 2 - 480, 940);
  ctx.lineTo(W / 2 - 160, 940);
  ctx.moveTo(W / 2 + 160, 940);
  ctx.lineTo(W / 2 + 480, 940);
  ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,0.7)';
  ctx.font = '22px Georgia, serif';
  ctx.fillText(dateStr, W / 2 - 320, 975);
  ctx.fillText('BWGELA', W / 2 + 320, 975);
  ctx.fillStyle = 'rgba(255,255,255,0.45)';
  ctx.font = '18px Georgia, serif';
  ctx.fillText('Date', W / 2 - 320, 1000);
  ctx.fillText('Awarded by', W / 2 + 320, 1000);

  if (logos.length) {
    const h = 44;
    const gap = 30;
    const ws = logos.map(img => img.width * h / img.height);
    let x = W / 2 - (ws.reduce((a, b) => a + b, 0) + gap * (logos.length - 1)) / 2;
    ctx.globalAlpha = 0.7;
    logos.forEach((img, i) => { ctx.drawImage(img, x, 866, ws[i], h); x += ws[i] + gap; });
    ctx.globalAlpha = 1;
  }

  if (code) {
    ctx.fillStyle = 'rgba(255,255,255,0.45)';
    ctx.font = '16px Georgia, serif';
    ctx.fillText(`Certificate code ${code} . To verify, email admin@bwgela.com quoting this code`, W / 2, 1052);
  }

  if (sample) {
    ctx.save();
    ctx.translate(W / 2, H / 2);
    ctx.rotate(-0.35);
    ctx.fillStyle = 'rgba(245,245,220,0.06)';
    ctx.font = '600 260px Georgia, serif';
    ctx.fillText('SAMPLE', 0, 90);
    ctx.restore();
  }
  return canvas;
};

export const ENGLISH_CERT_ACCENTS = {
  'pre-intermediate': { bg: '#D8C19A', text: '#2a2216' },
  intermediate: { bg: '#1E3A5F', text: '#ffffff' },
  advanced: { bg: '#7A1F1F', text: '#ffffff' }
};

export const ENGLISH_CERT_TITLE = 'Trivium English for Professionals';

export const ENGLISH_CERT_DETAIL = '24 lessons . Reading, Listening, Comprehension, Grammar, Vocabulary, Writing and Critical Thinking';

export const AON_CERT_DETAIL = '24 lessons . Reading, Listening, Comprehension, Grammar, Vocabulary, Writing, Critical Thinking and Speaking';

export const certAccent = (levelId, aon) => (aon && levelId === 'pre-intermediate' ? { bg: '#5EEAD4', text: '#0b2f2b' } : ENGLISH_CERT_ACCENTS[levelId]);

export const getStoredCompany = () => {
  try { return JSON.parse(localStorage.getItem('bwgela_company') || 'null'); } catch (e) { return null; }
};

export const isAonTheme = (pathId) => pathId === 'english-language' && getStoredCompany()?.theme === 'teal';

// The AON trial course: its own title, a code per level, and every return link goes to the AON page.
export const AON_COURSE_TITLE = 'Trivium: English for AON Professionals';
const AON_LEVEL_CODES = { 'pre-intermediate': 'AON101', intermediate: 'AON102', advanced: 'AON103' };
export const aonLevelCode = (levelId) => AON_LEVEL_CODES[levelId] || null;
export const aonPage = () => `/corporate/aon/${getStoredCompany()?.linkId || ''}`;

const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const makeCertCode = () => {
  const pick = () => Array.from({ length: 4 }, () => CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)]).join('');
  return `BWG-${pick()}-${pick()}`;
};

export const TRIVIUM_THEMES = {
  'pre-intermediate': { cls: 'trivium-pink', accent: '#F9A8D4', bg: '#F9A8D4', text: '#000000' },
  intermediate: { cls: 'trivium-blue', accent: '#93C5FD', bg: '#1E3A8A', text: '#FFFFFF' },
  advanced: { cls: 'trivium-red', accent: '#FCA5A5', bg: '#7F1D1D', text: '#FFFFFF' },
};
